export default __webpack_public_path__ + "static/media/element_spec_72.4025d8ae.webp";